export const DISTRICTS_MAP = '12GZW3A2aMVzhBz_VoTrzbaAxy9uzaqUS0ltJl78D';
export const MICRODISTRICTS_MAP = '1GwBebhDkJkWFImZ9te0862yLepiG80-Uc61zkf0i';
export const ZOOM = 12;

export const regionsLabels = [
  { index: '', name: 'Лазаревский', lng: 39.48898, lat: 43.84542 },
  { index: '', name: 'Хостинский', lng: 39.80827, lat: 43.558 },
  { index: '', name: 'Центральный', lng: 39.72038, lat: 43.62663 },
  { index: '', name: 'Адлерский', lng: 40.01426, lat: 43.55252 }
];

export const microregionsLabels = [
  { index: '', name: 'Донская', lng: 39.727249, lat: 43.62626 },
  { index: '', name: 'Завокзальный', lng: 39.735746, lat: 43.592763 },
  { index: '', name: 'Заречный', lng: 39.729746, lat: 43.598763 },
  { index: '', name: 'КСМ', lng: 39.746904, lat: 43.644771 },
  { index: '', name: 'Макаренко', lng: 39.749222, lat: 43.621662 },
  { index: '', name: 'Мамайка низ', lng: 39.692659, lat: 43.635237 },
  { index: '', name: 'Мамайка Верх', lng: 39.710169, lat: 43.641076 },
  { index: '', name: 'Новый Сочи', lng: 39.713173, lat: 43.608737 },
  { index: '', name: 'Клубничная', lng: 39.710984, lat: 43.622563 },
  { index: '', name: 'Центр', lng: 39.722571, lat: 43.583717 },
  { index: '', name: 'Ахун', lng: 39.823036, lat: 43.54158 },
  { index: '', name: 'Бытха', lng: 39.766388, lat: 43.565964 },
  { index: '', name: 'Кудепста', lng: 39.894962, lat: 43.496643 },
  { index: '', name: 'Мацеста', lng: 39.799862, lat: 43.562108 },
  { index: '', name: 'Приморье', lng: 39.776344, lat: 43.554893 },
  { index: '', name: 'Раздольное село', lng: 39.778061, lat: 43.589219 },
  { index: '', name: 'Светлана низ', lng: 39.736261, lat: 43.572432 },
  { index: '', name: 'Светлана верх', lng: 39.742184, lat: 43.581137 },
  { index: '', name: 'Соболевка', lng: 39.747162, lat: 43.590463 },
  { index: '', name: 'Яна Фабрициуса', lng: 39.749823, lat: 43.572991 },
  { index: '', name: 'Хоста', lng: 39.867496, lat: 43.519676 },
  { index: '', name: 'Транспортная', lng: 39.754543, lat: 43.60333 },
  { index: '', name: 'Адлер-Центр', lng: 39.916935, lat: 43.43466 },
  { index: '', name: 'Блиново', lng: 39.975557, lat: 43.4197 },
  { index: '', name: 'Веселое село', lng: 40.000362, lat: 43.406045 },
  { index: '', name: 'Голубые дали', lng: 39.905262, lat: 43.453667 },
  { index: '', name: 'Красная Поляна пос.', lng: 40.201721, lat: 43.673335 },
  { index: '', name: 'Курортный городок', lng: 39.89831, lat: 43.47329 },
  { index: '', name: 'Мирный пос.', lng: 39.959164, lat: 43.413465 },
  { index: '', name: 'Молдовка село', lng: 39.961052, lat: 43.461766 },
  { index: '', name: 'Орел-Изумруд село', lng: 39.926376, lat: 43.461953 },
  { index: '', name: 'Южный культуры', lng: 39.933157, lat: 43.419762 },
  { index: '', name: 'Имеретинская низменность', lng: 39.964914, lat: 43.403613 },
  { index: '', name: 'Лоо пос.', lng: 39.588547, lat: 43.707221 },
  { index: '', name: 'Дагомыс пос.', lng: 39.674034, lat: 43.670976 },
  { index: '', name: 'Лазаревский пос.', lng: 39.334831, lat: 43.911621 }
];

export const USER_ROLE = {
  INDIVIDUAL: 'INDIVIDUAL',
  WORKER: 'WORKER',
  ADMIN: 'ADMIN'
};

export const TARIFFS = {
  COMPANY: 'company',
  PERSONAL: 'personal',
  COMPANY_TEST: 'personalTest',
  PERSONAL_TEST: 'companyTest'
};



// WEBPACK FOOTER //
// ./src/constants/index.js